import { CardsCatalog } from "../../../models/catalog.model";

export function addDefaultDeckIfNoDecks() {
  let championsDecks = localStorage.getItem("decks")
    ? JSON.parse(localStorage.getItem("decks"))
    : [];
  if (championsDecks.length === 0) {
    localStorage.setItem("decks", JSON.stringify(DEFAULT_DECKS));
  }
}

export const DEFAULT_DECKS = [
  {
    name: "Spiderman - Justice",
    uid: "mocked0",
    content: [
      {
        card: CardsCatalog.spiderMan,
        counter: 1
      },
      {
        card: CardsCatalog.blackCatFeliciaHardy,
        counter: 1
      },
      {
        card: CardsCatalog.backflip,
        counter: 2
      },
      {
        card: CardsCatalog.enhancedSpiderSense,
        counter: 2
      },
      {
        card: CardsCatalog.webShooter,
        counter: 2
      },
      {
        card: CardsCatalog.webbedUp,
        counter: 2
      },
      {
        card: CardsCatalog.spiderTracer,
        counter: 2
      },
      {
        card: CardsCatalog.auntMay,
        counter: 1
      },
      {
        card: CardsCatalog.swingingWebKick,
        counter: 3
      },
      {
        card: CardsCatalog.daredevilMattMurdock,
        counter: 1
      },
      {
        card: CardsCatalog.jessicaJones,
        counter: 1
      },
      {
        card: CardsCatalog.forJustice,
        counter: 2
      },
      {
        card: CardsCatalog.greatResponsibility,
        counter: 2
      },
      {
        card: CardsCatalog.thePowerOfJustice,
        counter: 3
      },
      {
        card: CardsCatalog.interrogationRoom,
        counter: 3
      },
      {
        card: CardsCatalog.surveillanceTeam,
        counter: 3
      },
      {
        card: CardsCatalog.heroicIntuition,
        counter: 3
      },
      {
        card: CardsCatalog.followed,
        counter: 3
      },
      {
        card: CardsCatalog.concussiveBlow,
        counter: 3
      }
    ]
  }
];
